
import { defineComponent, ref, computed, PropType } from 'vue';
import { PlatformLogsFilters } from '@/interfaces/panel/platform-logs.model';

export default defineComponent({
  name: 'PlatformLogsFilters',
  props: {
    filters: {
      type: Object as PropType<PlatformLogsFilters>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['apply', 'reset'],
  setup(props, { emit }) {
    const localFilters = ref<PlatformLogsFilters>({ ...props.filters });
    const showAdvanced = ref(false);
    const showMoreFilters = ref(false);

    const typeOptions = [
      { text: 'عملیات کاربر', value: 'USER_ACTION' },
      { text: 'عملیات ادمین', value: 'ADMIN_ACTION' },
      { text: 'عملیات سیستم', value: 'SYSTEM_ACTION' },
      { text: 'مالی', value: 'FINANCIAL' },
      { text: 'امنیتی', value: 'SECURITY' },
    ];

    const statusOptions = [
      { text: 'موفق', value: 'SUCCESS' },
      { text: 'ناموفق', value: 'FAILED' },
      { text: 'در انتظار', value: 'PENDING' },
    ];

    const deviceOptions = [
      { text: 'دسکتاپ', value: 'desktop' },
      { text: 'موبایل', value: 'mobile' },
      { text: 'تبلت', value: 'tablet' },
      { text: 'نامشخص', value: 'unknown' },
    ];

    const activeFiltersCount = computed(() => {
      let count = 0;
      if (localFilters.value.search) count++;
      if (localFilters.value.type && localFilters.value.type.length > 0) count++;
      if (localFilters.value.status && localFilters.value.status.length > 0) count++;
      if (localFilters.value.userId) count++;
      if (localFilters.value.referenceId) count++;
      if (localFilters.value.userEmail) count++;
      if (localFilters.value.adminEmail) count++;
      if (localFilters.value.targetEmail) count++;
      if (localFilters.value.from) count++;
      if (localFilters.value.to) count++;
      if (localFilters.value.ip) count++;
      if (localFilters.value.device) count++;
      if (localFilters.value.actionContains) count++;
      if (localFilters.value.hasError) count++;
      if (localFilters.value.isRead !== undefined) count++;
      return count;
    });

    const toggleAdvancedFilters = () => {
      showAdvanced.value = !showAdvanced.value;
    };

    const applyFilters = () => {
      emit('apply', { ...localFilters.value });
    };

    const resetFilters = () => {
      localFilters.value = {
        page: 1,
        pageSize: 25,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        includeTotals: true,
        withRelations: true,
      };
      emit('reset');
    };

    return {
      localFilters,
      showAdvanced,
      showMoreFilters,
      typeOptions,
      statusOptions,
      deviceOptions,
      activeFiltersCount,
      toggleAdvancedFilters,
      applyFilters,
      resetFilters,
    };
  },
});
